import { render } from "./VInputRadio.vue?vue&type=template&id=123a88dc&scoped=true&ts=true"
import script from "./VInputRadio.vue?vue&type=script&lang=ts"
export * from "./VInputRadio.vue?vue&type=script&lang=ts"

import "./VInputRadio.vue?vue&type=style&index=0&id=123a88dc&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123a88dc"]])

export default __exports__